import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ClientLoggerService } from '@core/logging/client-logger.service';
import { environment } from '@env/environment';
import { sanitizeUrl } from '@core/logging/safe-log-sanitizer';

const EXCLUDED_URL_PATTERNS = [
  /\/client-error-logs\//i,
  /\/analytics\//i,
];

export const clientErrorTelemetryInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(ClientLoggerService);
  const startedAt = performance.now();

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (environment.logging.captureHttpErrors && shouldCaptureHttpError(req.url, error)) {
        const durationMs = Math.round(performance.now() - startedAt);
        logger.error('HTTP request failed', error, {
          source: 'http-interceptor',
          metadata: {
            method: req.method,
            url: sanitizeUrl(req.urlWithParams),
            status: error.status,
            statusText: error.statusText,
            durationMs,
          },
        });
      }

      return throwError(() => error);
    }),
  );
};

const shouldCaptureHttpError = (url: string, error: HttpErrorResponse): boolean => {
  if (EXCLUDED_URL_PATTERNS.some((pattern) => pattern.test(url))) return false;
  return error.status === 0 || error.status === 408 || error.status === 429 || error.status >= 500;
};
